import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import LoginScreen from './Components/LoginScreen';
import DashboardScreen from './Components/Dashboardscreen';
import RegistrationStep1 from './Components/registration/RegistrationStep1';
import RegistrationStep2 from './Components/registration/RegistrationStep2';
import RegistrationStep3 from './Components/registration/RegistrationStep3';
import RegistrationStep4 from './Components/registration/RegistrationStep4';
import RegistrationView from './Components/registration/RegistrationView';
import AdmissionScreen from './Components/AdmissionScreen';
import SuccessModal from './Components/common/SuccessModel';
import StudentAnalytics from './Components/StudentAnalytics';
import PayCardDetails from './Components/PayCardDetails';
import StudentFeeDetails from './Components/StudentFeeDetails';
import FinanceScreen from './Components/Financescreen';
import RoomAllocationScreen from './Components/Roomallocationscreen ';
import InventoryScreen from './Components/Inventoryscreen';
import UserManagementScreen from './Components/UserManagementScreen';
import GuestRegistration from './Components/GuestRegistration';
import CanteenScreen from './Components/CanteenScreen';
import NotificationsScreen from './Components/NotificationsScreen';
import PayCardOperations from './Components/PayCardOperations';

/* ─── Main staff app — all existing navigation unchanged ─── */
const MainApp = () => {
  const [currentScreen,    setCurrentScreen]    = useState(() => localStorage.getItem('currentScreen') || 'login');
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const viewRegistrationIdRef = useRef(null);
  const viewStudentIdRef      = useRef(null);
  const [navKey, setNavKey]   = useState(0);
  const feeStudentIdRef       = useRef(null);
  const payCardStudentIdRef   = useRef(null);

  useEffect(() => { localStorage.setItem('currentScreen', currentScreen); }, [currentScreen]);

  const navigateTo = useCallback((screen, params = {}) => {
    if (params.registrationId)   viewRegistrationIdRef.current = params.registrationId;
    if (params.studentId)        viewStudentIdRef.current       = params.studentId;
    if (params.feeStudentId)     feeStudentIdRef.current        = params.feeStudentId;
    if (params.payCardStudentId) payCardStudentIdRef.current    = params.payCardStudentId;

    if (screen === 'registration1' && !params.isBack) {
      localStorage.removeItem('registrationStep1Data');
      localStorage.removeItem('registrationStep2Data');
      localStorage.removeItem('registrationStep3Data');
      localStorage.removeItem('registrationPhotoPreview');
      window.selectedPhotoFile = null;
      window.selectedDocFiles  = null;
      sessionStorage.removeItem('regPhotoData');
    }

    setCurrentScreen(screen);
    setNavKey(k => k + 1);
    window.scrollTo(0, 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLogout = () => {
    localStorage.removeItem('currentScreen');
    setCurrentScreen('login');
  };

  return (
    <div className="app">
      {currentScreen === 'login'             && <LoginScreen onLogin={() => navigateTo('dashboard')} onNavigate={navigateTo} />}
      {currentScreen === 'dashboard'         && <DashboardScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'registration1'     && <RegistrationStep1 onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'registration2'     && <RegistrationStep2 onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'registration3'     && <RegistrationStep3 onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'registration4'     && <RegistrationStep4 onNavigate={navigateTo} onSubmit={() => setShowSuccessModal(true)} onLogout={handleLogout} />}
      {currentScreen === 'registrationView'  && <RegistrationView onNavigate={navigateTo} onLogout={handleLogout} registrationId={viewRegistrationIdRef.current} />}
      {currentScreen === 'admission'         && <AdmissionScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'studentAnalytics'  && <StudentAnalytics key={`analytics-${navKey}`} onNavigate={navigateTo} onLogout={handleLogout} studentId={viewStudentIdRef.current} />}
      {currentScreen === 'rooms'             && <RoomAllocationScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'inventory'         && <InventoryScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'canteen'           && <CanteenScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'notifications'    && <NotificationsScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'finance'           && <FinanceScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'studentFeeDetails' && <StudentFeeDetails onNavigate={navigateTo} onLogout={handleLogout} studentId={feeStudentIdRef.current} />}
      {currentScreen === 'payCardDetails'    && <PayCardDetails onNavigate={navigateTo} onLogout={handleLogout} studentId={payCardStudentIdRef.current} />}
      {currentScreen === 'users'             && <UserManagementScreen onNavigate={navigateTo} onLogout={handleLogout} />}
  {currentScreen === 'payCardOperations' && <PayCardOperations onNavigate={navigateTo} onLogout={handleLogout} />}
      {showSuccessModal && <SuccessModal onClose={() => {
        setShowSuccessModal(false);
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const role = (user?.role || '').toUpperCase();
        navigateTo(role === 'STUDENT' ? 'rooms' : 'dashboard');
      }} />}
    </div>
  );
};

/* ─── Root App ─── */
function App() {
  return (
    <Routes>
      {/* Public guest registration — no login needed */}
      <Route path="/register" element={<GuestRegistration />} />

      {/* All other paths → staff login + app */}
      <Route path="/*" element={<MainApp />} />
    </Routes>
  );
}

export default App;